export const getCurrencyConfig = (currencyCode?: string) => {
  const currency = currencyCode?.toUpperCase() || "TK";
  const symbol = currency === "USD" ? "$" : "TK";
  return {
    currency,
    symbol,
  };
};

export const formatCurrency = (amount: number, currencyCode?: string) => {
  const { symbol } = getCurrencyConfig(currencyCode);

  const formatted = (amount ?? 0).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return `${symbol} ${formatted}`;
};
